import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import RoutePage from "./routes/RoutePage";
import { useAuth } from "./Hooks/useAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { useDeviceDetection } from "./Hooks/useDeviceDetection";
import { useLocation } from "react-router-dom";
import DesktopOnlyScreen from "./components/desktop-only-screen/desktop-only-screen.component";

function App() {
  useAuth();
  const [isCheckMobile, setIsCheckMobile] = useState(false);
  const location = useLocation();
  const isMobile = useDeviceDetection(); // Enhanced mobile detection for larger phones

  // Check if current route is external business registration
  const isExternalBusinessRegistration = location.pathname.startsWith(
    "/external-business-registration"
  );

  useEffect(() => {
    if (isMobile && !isExternalBusinessRegistration) {
      setIsCheckMobile(true);
    } else {
      setIsCheckMobile(false);
    }
  }, [isMobile, isExternalBusinessRegistration]);

  return (
    <div>
      {isCheckMobile ? (
        <DesktopOnlyScreen />
      ) : (
        <>
          <RoutePage />
          <ToastContainer />
        </>
      )}
    </div>
  );
}

export default App;
